module.exports = __webpack_public_path__ + "img/课程建设方案.9a0fc610.svg";